import { message, Modal, Popover } from 'antd';
import dayjs from 'dayjs';
import qs from 'qs';
import React, { useCallback, useState } from 'react';
import { api } from '../../../fetch/bussiness/api';
import {
  formatFetchUrl,
  parseApiTemplate,
} from '../../../fetch/bussiness/util';
import { request } from '../../../fetch/core';
import { HttpStatusCode } from '../../../fetch/core/constant';
import { clstagStr } from '@/utils/util';
import { CLSTAG } from '@/utils/constant';
interface Props {
  disabled: boolean;
  onShowMessage: (name: string) => void;
}

const MessageMap = new Map([
  [
    'POWER_OFF',
    {
      text: '下电指令下发后将无法撤回，您是否确认将无人车远程关机？',
      pathUri: api.powerOff,
    },
  ],
  [
    'REBOOT',
    {
      text: '重启指令下发后将无法撤回，您是否确认将无人车断电重启？',
      pathUri: api.reboot,
    },
  ],
  [
    'RESTART',
    {
      text: '是否确定软件重启？',
      pathUri: api.restart,
    },
  ],
  [
    'POWER_ON',
    {
      text: '是否确定无人车远程开机？',
      pathUri: api.powerOn,
    },
  ],
]);

const btnGroup: any[] = [
  {
    text: '远程下电',
    commandType: 'POWER_OFF',
    clstag: clstagStr(CLSTAG.PowerOff),
  },
  {
    text: '断电重启',
    commandType: 'REBOOT',
    clstag: clstagStr(CLSTAG.ReBoot),
  },
  {
    text: '软件重启',
    commandType: 'RESTART',
    clstag: clstagStr(CLSTAG.ReStart),
  },
  {
    text: '远程开机',
    commandType: 'POWER_ON',
    clstag: clstagStr(CLSTAG.PowerOn),
  },
];

const ReStart = (props: Props) => {
  const { disabled } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const handleClick = (commandType: string) => {
    Modal.confirm({
      className: 'command-confirm',
      title: MessageMap.get(commandType)!.text,
      onOk: onOk.bind(null, commandType),
    });
  };

  const sendCommand = async (path: string, data: any) => {
    const res = await request({
      method: 'POST',
      path,
      body: data,
    });
    return res;
  };

  const onOk = useCallback((commandType) => {
    const info = MessageMap.get(commandType);
    const query = qs.parse(window.location.search.split('?')[1]);
    const vehicleName = query && query.license;
    let path: string = '';
    let powerManagerAction: string = '';
    const [pathUri, action] = parseApiTemplate(info!.pathUri);
    path = pathUri;
    const commandObj = {
      vehicleName: vehicleName,
      timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
    };
    switch (info!.pathUri) {
      case api.powerOff:
        powerManagerAction = 'POWER_OFF';
        Object.assign(commandObj, { powerManagerAction });
        break;
      case api.reboot:
        powerManagerAction = 'REBOOT';
        Object.assign(commandObj, { powerManagerAction });
        break;
      case api.restart:
        path = formatFetchUrl(info!.pathUri, {
          vehicleName,
        });
        break;
      case api.powerOn:
        path = api.powerOn;
        Object.assign(commandObj, { operateType: 'powerOn' });
        break;
      default:
        break;
    }
    props.onShowMessage(commandType);
    sendCommand(path, commandObj).then((res) => {
      if (res.code == HttpStatusCode.Success) {
        if (commandType === 'RESTART') {
          sendCommand(api.recovery, {
            vehicleName: vehicleName,
            timeStamp: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          });
        }
      } else {
        message.error(res.message);
      }
    });
  }, []);

  const popContent = (
    <div className="pop-content">
      {btnGroup.map((item) => (
        <div
          key={item.commandType}
          onClick={handleClick.bind(null, item.commandType)}
          clstag={item.clstag}
        >
          {item.text}
        </div>
      ))}
    </div>
  );

  const handleVisibleChange = (value: boolean) => {
    if (disabled) {
      setVisible(false);
    } else {
      setVisible(value);
    }
  };
  return (
    <Popover
      content={popContent}
      trigger="hover"
      open={visible}
      onOpenChange={handleVisibleChange}
    >
      <li className="item restart">
        {!disabled ? (
          <div className="img_normal" />
        ) : (
          <div className="img_gray" />
        )}
        <h3 className="operate_key">远程重启</h3>
      </li>
    </Popover>
  );
};
export default ReStart;
